import React, { useEffect, useState  } from 'react';
import { FilePicker,Button, IconPlus,InlineNotification } from "@veneer/core";
import { Col, Row } from "react-bootstrap";
import ConnectAPI from '../../services/api';
const connectApi = new ConnectAPI();
function Uploadfile( ) {
    const [fileconsumable,setfileconsumable]=useState();
    const [title, settittle]=useState("");
    const [messagetype, setmessagetype]=useState("");
    const [showdialog, setshowdialog]=useState(false);
    function submit (){ 
        if(fileconsumable){
            /*console.log("tengo data");
            setmessagetype("positive");
            settittle("file detected");
            setshowdialog(true);*/
            let data = new FormData();
            data.append("fileconsumable", File);
            data.append("fileconsumable",fileconsumable);
             connectApi.postmultifile(
                "api/Channels/uploadconsumablefile",
                data,
                handleReloadData2
            ).catch((error) => {
                setmessagetype("warning");
                settittle("Upload Error");
                setshowdialog(true);
                setTimeout(hidealert, 3000);
            });
            
        }else{
            setmessagetype("warning");
            settittle("not file detected");
            setshowdialog(true);
            setTimeout(hidealert, 3000);
        }
    }
    const handleReloadData2 = (status,data) => {
            if(status==200){
                window.location.reload();
            }

        }
    function hidealert() {
        setshowdialog(false);
    }
    return(
       <>
       <Row>
            <Col>
                <FilePicker
                    id="consumablefile"
                    separateLabel
                    label="consumable file"
                    accept=".xlsx,.xls"
                    onChange={(event)=>{
                        setfileconsumable(event.target.files[0])
                    }}
                />
            </Col>
            <Col xs lg="2">
                <Button leadingIcon={<IconPlus />} onClick={submit}>Upload</Button>
            </Col>
            <Col>
                {showdialog?(
                    <div style={{marginLeft:10}}>
                        <InlineNotification
                            title={title}
                            type={messagetype}
                        />
                    </div>
                ):undefined}
            </Col>
        </Row>
        
       </>
    );
}
export default Uploadfile;